export default "__VITE_ASSET__a8ffd44c__"